import type { Mission } from '../missions.ts'

export const fcc: Mission = {
  id: "fcc",
  name: "Federal Communications Commission",
  short: "FCC",
  call: "Communications",
  kind: "independent",
  url: "https://www.fcc.gov/",
  established: 1934,
  palette: {
    primary: "#1c3664",
    secondary: "#726658",
    accent: "#ca992c",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Federal_Communications_Commission.svg",
  },
  motif: "eagle",
  mission: {
    text: "A U.S. government agency overseen by Congress, the Commission is the federal agency responsible for implementing and enforcing America’s communications law & regulations.",
    url: "https://www.fcc.gov/about/overview",
  },
  fact: {
    text: "The FCC replaced the Federal Radio Commission in 1934, taking over its oversight of radio broadcasting.",
    url: "https://www.fcc.gov/media/radio/history-of-commercial-radio",
  },
  seal: {
    file: "public/seals/fcc.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Federal_Communications_Commission.svg",
  },
  logo: {
    file: "public/logos/fcc.svg",
    source: "https://commons.wikimedia.org/wiki/File:FCC_New_Logo.svg",
  },
  identifier: {
    about: "https://www.fcc.gov/about/overview",
    accessibility: "https://www.fcc.gov/accessibility/program",
    foia: "https://www.fcc.gov/foia",
    noFear: "https://www.fcc.gov/owd/no-fear-act-annual-report",
    oig: "https://www.fcc.gov/inspector-general",
    performance: "https://www.fcc.gov/about/strategic-plans-budget",
    privacy: "https://www.fcc.gov/general/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/fcc-goldstone.jpg",
        small: "/media/fcc-goldstone-sm.jpg",
        alt: "Large white radio antenna dishes in the Mojave Desert lit at dawn",
        title: "Dawn in the Apollo Valley, Goldstone Deep Space Communications Complex",
        creator: "NASA/JPL-Caltech",
        source: "https://commons.wikimedia.org/wiki/File:Dawn_in_the_Apollo_Valley,_Goldstone_Deep_Space_Communications_Complex.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/fcc-listening-post.jpg",
        small: "/media/fcc-listening-post-sm.jpg",
        alt: "Two radio monitors with headphones, seen from behind, working banks of receivers at an FCC listening post",
        title: "Laurel, Maryland. Monitoring at the United States Federal Communications Commission listening post",
        creator: "Lewis Walker, U.S. Office of War Information",
        source: "https://www.loc.gov/pictures/item/2017866358/",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
